// src/App.tsx
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import AdminUploadPage from "./pages/AdminUploadPage";
import HomePage from "./pages/HomePage";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";

import { onAuthStateChanged, User } from "firebase/auth";
import { auth } from "./firebase";

const ADMIN_UID = "n5pA5jZrjUcl9jew8BppuL4niR93";

function RequireAdmin({ children }: { children: React.ReactElement }) {
  const [user, setUser] = React.useState<User | null>(null);
  const [checking, setChecking] = React.useState(true);

  React.useEffect(() => {
    const unsub = onAuthStateChanged(auth, (u) => {
      setUser(u);
      setChecking(false);
    });
    return () => unsub();
  }, []);

  if (checking) return <div style={{ padding: 16 }}>認証確認中...</div>;

  // 未ログイン or 管理者でない場合はトップへ
  if (!user || user.uid !== ADMIN_UID) return <Navigate to="/" replace />;

  return children;
}

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route
          path="/admin"
          element={
            <RequireAdmin>
              <AdminUploadPage />
            </RequireAdmin>
          }
        />
      </Routes>
    </BrowserRouter>
  );
};

export default App;